var map = {
	"./light_1.png": "046a",
	"./light_10.png": "e035",
	"./light_11.png": "4782",
	"./light_12.png": "87a0",
	"./light_2.png": "79fb",
	"./light_3.png": "843c",
	"./light_4.png": "59e8",
	"./light_5.png": "4d02",
	"./light_6.png": "03d6",
	"./light_7.png": "5a1c",
	"./light_8.png": "e3bd",
	"./light_9.png": "5cfe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "20ba";